import $ from 'jquery'
import { toolkitUrls } from '@/links'

export { getUserFavorites, deleteUserFavorite }

function getUserFavorites(userUuid, settings) {
  var param = $.param(settings)
  return $.ajax({
    url: `${toolkitUrls.api}/collections/${userUuid}/favorites?${param}`,
    method: 'GET',
    xhrFields: { withCredentials: true },
  })
}

function deleteUserFavorite(contentId) {
  return $.ajax({
    url: `${toolkitUrls.api}/collections/${contentId}/favorites`,
    method: 'DELETE',
    xhrFields: { withCredentials: true },
  })
}
